import { HelpContent } from '../../../../UI-Lib/Help-Tooltip';

export const PARCEL_BULK_UPDATE_HELP: HelpContent[] = [
    {
        helpContentId: 'parcel-bulk-update.header',
        tooltipText: 'Bulk Update',
        hasIcon: true
    }
];
